// extracted by mini-css-extract-plugin
export default {"tooltip":"co-z","sharingV2":"do-z","sharingIconsV2":"eo-z","links":"fo-z","link":"go-z","facebookV2":"ho-z","twitterV2":"io-z","pinterestV2":"jo-z"};